import calculatorReducer from './calculatorReducer';

export const mainCalculatorReducer = {
  cost: calculatorReducer,
};
